import React, { useEffect, useState, useCallback } from "react";
import Table from "../../common/Table/table";
import AddUpdateCamp from "./AddUpdateCamp";
import { useDispatch, useSelector } from "react-redux";
import {
  getCamp,
  createCamp,
  updateCamp,
  deleteCamp,
  getCampById,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
} from "../../../store/slices/campSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { Modal } from "react-bootstrap";
import FormData from "form-data";
import ViewModal from "../../common/viewModal/globalViewModal";

const Camp = () => {
  const dispatch = useDispatch();
  const {
    camp,
    createCampSuccessMessage,
    createCampErrorMessage,
    updateCampSuccessMessage,
    updateCampErrorMessage,
    deleteCampSuccessMessage,
    deleteCampErrorMessage,
    searchMessage,
    campInfo,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.Camp);

  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [showModal, setModalVisible] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [modalAction, setModalAction] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const [inputError, setInputError] = useState({
    name: false,
    phNumber: false,
  });
  const [imagePreview, setImagePreview] = useState({ campImage: null });


const clinicId =clinicInfo?.[0]?.clinicId;

  const initialState = {
    id: "",
    clinicId: "",
    name: "",
    status: "Active",
    organizer: "",
    address: "",
    phoneNumber: "",
    remark: "",
    service: { value: "", label: "" },
    campImage: null,
  };
  const [formData, setFormData] = useState(initialState);
  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Organizer", key: "organizer" },
    { title: "Number", key: "phoneNumber" },
    { title: "Service", key: "service" },
    { title: "Status", key: "status" },
  ];
  const title = [
    { title: "Name", key: "name" },
    { title: "Organizer", key: "organizer" },
    { title: "Status", key: "status" },
    { title: "Phone Number", key: "phoneNumber" },
    { title: "Address", key: "address" },
    { title: "Service", key: "service" },
    { title: "Remark", key: "remark" },
  ];
  const fetchCamps = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getCamp({
            clinicId,
            token,
            status: tableStatus,
            currentPage: page,
            limit: lim,
            name: search || undefined,
          })
        );
      }
    },
    [dispatch, clinicInfo, token, tableStatus, searchValue, pageLimit]
  );

  useEffect(() => {
    fetchCamps();
  }, [fetchCamps, showModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchCamps(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchCamps(1, newLimit, searchValue);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchCamps(1, pageLimit, value);
  };
  useEffect(() => {
    showTostifyMessageAndReset(
      createCampSuccessMessage,
      showToastifySuccess,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      createCampErrorMessage,
      showToastifyError,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      updateCampSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      updateCampErrorMessage,
      showToastifyError,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      deleteCampSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages
    );
    showTostifyMessageAndReset(
      deleteCampErrorMessage,
      showToastifyError,
      resetDeleteMessages
    );
  }, [
    createCampSuccessMessage,
    createCampErrorMessage,
    updateCampSuccessMessage,
    updateCampErrorMessage,
    deleteCampSuccessMessage,
    deleteCampErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const handleChange = (e, field = null) => {
    if (field === "services") {
      setFormData((prev) => ({
        ...prev,
        service: {
          value: e?.value || "",
          label: e?.label || "",
        },
      }));
    } else if (e?.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else if (e?.editor) {
      setFormData((prev) => ({ ...prev, remark: e.editor.getData() }));
    }
  };
  const handleFileChange = (file) => {
    if (file) {
      setFormData((prev) => ({ ...prev, campImage: file }));
      setImagePreview({ campImage: URL.createObjectURL(file) });
    }
  };

  const stripHtmlTags = (html) =>
    html ? html.replace(/<[^>]*>/g, "") : "";

  const handleModal = () => {
    setFormData(initialState);
    setModalVisible(true);
    setModalAction("create");
  };

  const handleEdit = (item) => {
    setFormData({
      id: item?.id || "",
      name: item?.name || "",
      status: item?.status || "",
      organizer: item?.organizer || "",
      address: item?.address || "",
      phoneNumber: item?.phoneNumber || "",
      remark: item?.remark,
      service: {
        value: item?.serviceId || "",
        label: item?.service || "",
      },
      campImage: item?.campImage || null,
    });
    setModalVisible(true);
    setModalAction("edit");
  };

  const handleAddOrUpdateCamp = async (e) => {
    e.preventDefault();

    if (inputError.name || inputError.phNumber) {
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("id", formData.id);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("status", formData.status);
    formDataToSend.append("organizer", formData.organizer);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("phoneNumber", formData.phoneNumber);
    formDataToSend.append("remark", formData.remark);
    formDataToSend.append("service", formData.service?.value);
    formDataToSend.append("clinicId", clinicId);
    formDataToSend.append("campImage", formData.campImage);
    try {
      
      if (modalAction === "create") {
        await dispatch(createCamp({ formDataToSend, token }));
      } else {
        await dispatch(updateCamp({ formDataToSend, token }));
      }
      setModalVisible(false);
      setFormData(initialState);
      setImagePreview({});
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleDelete = (item) => {
    setFormData({
      id: item?.id || "",
      name: item?.name || "",
      status: item?.status || "",
      organizer: item?.organizer || "",
      address: item?.address || "",
      phoneNumber: item?.phoneNumber || "",
      remark: item?.remark,
      service: {
        value: item?.serviceId || "",
        label: item?.service || "",
      },
    });
    setDeleteModalVisible(true);
  };

  const handelDeleteClientType = async (e) => {
    try {
      await dispatch(
        deleteCamp({
          id: formData?.id,
          clinicId,
          token,
        })
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error occurred while deleting client type:", error);
    }
  };

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(getCampById({ id: data.id, token }));
    setShowGlobalViewModal(true);
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("id", item?.id);
      formDataToSend.append("name", item?.name);
      formDataToSend.append("status", status);
      formDataToSend.append("organizer", item?.organizer);
      formDataToSend.append("address", item?.address);
      formDataToSend.append("phoneNumber", item?.phoneNumber);
      formDataToSend.append("remark", item?.remark);
      formDataToSend.append("service", item?.serviceId);
      formDataToSend.append("clinicId", clinicId);
      formDataToSend.append("campImage", item?.campImage);

      await dispatch(updateCamp({ formDataToSend, token }));
       fetchCamps(currentPage, pageLimit, searchValue);
  } catch (error) {
    console.error("Error updating camp status:", error);
  }
  };

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          camp &&
          camp?.map((item) => ({
            id: item?._id,
            name: item?.name,
            address: item?.address,
            organizer: item?.organizer,
            phoneNumber: item?.phoneNumber,
            service: item?.service?.serviceName,
            status: item?.status,
            serviceId: item?.service?._id,
            remark: item?.remark,
            campImage: item?.campImage,
          }))
        }
        addModal={handleModal}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        searchValue={searchValue}
        handleSearch={handleSearch}
        errorMessage={searchMessage}
        handleAddBtn={true}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      <AddUpdateCamp
        showModal={showModal}
        setModalVisible={setModalVisible}
        formData={formData}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        modalAction={modalAction}
        handleAddOrUpdateCamp={handleAddOrUpdateCamp}
        setInputError={setInputError}
        imagePreview={imagePreview}
        camp={camp}
      />

      <Modal centered show={showDeleteModal} onHide={() => setDeleteModalVisible(false)}>
        <div className="modal-header">
          <h5>Delete Camp</h5>
        </div>
        <div className="modal-body">
          Are you sure you want to delete <strong>{formData.name}</strong>?
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setDeleteModalVisible(false)}>
            Close
          </button>
          <button className="btn btn-danger" onClick={handelDeleteClientType}>
            Delete
          </button>
        </div>
      </Modal>

      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize="lg"
        titel={title}
        content={{
          name: campInfo?.list?.name,
          organizer: campInfo?.list?.organizer,
          status: campInfo?.list?.status,
          phoneNumber: campInfo?.list?.phoneNumber,
          address: campInfo?.list?.address,
          service: campInfo?.list?.service?.serviceName,
          remark: stripHtmlTags(campInfo?.list?.remark),
        }}
      />
    </div>
  );
};

export default Camp;
